import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../providers/api/api.service';
import { findIPAddressesByUserLoginRequest, getSiteByIPRequest } from './types';

@Injectable({
  providedIn: 'root'
})
export class EndpointService {
  private _paths = {
    findIPAddressesByUserLogin: '/user/user/v1/users/findIPAddressesByUserLogin',
    getSiteByIP: '/entity/v1/sites/findByIP'
  };

  private readonly unsubscribe: Subject<void> = new Subject();

  constructor(private readonly apiService: ApiService) {}

  public getIPAddressesByUserID(userid: number, startTime: number, endTime: number): Observable<findIPAddressesByUserLoginRequest> {
    return (
      this.apiService
        // eslint-disable-next-line
        .post$<any>(this._paths.findIPAddressesByUserLogin, {
          userid,
          startTime,
          endTime
        })
        .pipe(takeUntil(this.unsubscribe))
    );
  }

  public getSiteIDsByIPAddress(ip: string): Observable<getSiteByIPRequest[]> {
    return this.apiService
      .post$<any>(this._paths.getSiteByIP, [ip]) // eslint-disable-line
      .pipe(takeUntil(this.unsubscribe));
  }
}
